//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'mainMenuTab',
    props: ["menuId"],
	data() {
		return {
            menuList:[
                {default_inco:'icon_tab_index',active_inco:'icon_tab_index_active',tabName:"首页",url:'/home', disabled: true,},
                {default_inco:'icon_quick_buy',active_inco:'icon_quick_buy2',tabName:"快速购买",url:'/buy', disabled: true,},
                {default_inco:'icon_tab_order',active_inco:'icon_tab_order_active',tabName:"订单",url:'/member/order', disabled: true,},
                {default_inco:'icon_cart',active_inco:'iconinco_cart_active',tabName:"购物车",url:'/cart', disabled: true,},
                {default_inco:'icon_tab_my',active_inco:'icon_tab_my_active',tabName:"我的",url:'/member/my', disabled: true,},

            ]
		}
    },
    methods:{
        change(index,obj){
            if(!obj.disabled) return;
            let url=this.menuList[index].url;
            this.$router.push(url);
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/mainMenuTab.vue